<template>
  <div>
      <customer-profile v-if='customerObj' :customer-obj='customerObj' :hide-header='true' :user='User' :initiate-message='initiateMessage'></customer-profile>
  </div>
</template>

<script>
import CustomerProfile from '@/components/CustomerProfile/CustomerProfile'
import {mapGetters} from 'vuex'
export default {
    components: {
        CustomerProfile
    },
    computed: {
        ...mapGetters(['User']),
        initiateMessage: function(){
            let vm = this;
            if(vm.$route.query.message) return true;
            else return false
        },
        customerObj: function(){
            let vm = this;
            console.log('CUSTOMER ID', vm.$route.query.customerId)
            if(vm.$route.query.customerId){
                let customerObj = {}
                customerObj.AutoAlertCustomerID = vm.$route.query.customerId
                return customerObj
            }
            return false;
        }
    },
    created(){
        let vm = this;
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Dealsheet/DealsheetHome.vue